import React from 'react';
var HeaderAction = function (props) {
    var path = props.path, iconClass = props.iconClass;
    return (React.createElement("li", { className: "nav-item o-header-action" },
        React.createElement("a", { href: path, className: "nav-link o-header-action-btn" },
            React.createElement("i", { className: "fal " + iconClass }))));
};
export default React.memo(HeaderAction);
